import Panel from './panel';

export default class LandscapePanel extends Panel {
  // landscape panel is a different aspect ratio, so we need to center ourselves
  activate() {
    const panelWidth = this.tag.width;
    const screenWidth = window.innerWidth;

    const newOffset = this.offset + (panelWidth - screenWidth) / 2;

    setTimeout(() => {
      this.parent.panelContainer.style.transform = `translate(-${newOffset}px, 0)`;
    }, 0);
  }
}
